// unit: filter3
import f from "../../../funcs";
import Operator from "./operators/Operator";
import NoRows from "./operators/NoRows";
import "./operators/Equal";
import "./operators/NotEqual";
import "./operators/Is";
import "./operators/Contain";
import "./operators/Greater";
import "./operators/Lesser";
import "./operators/GreaterOrEqual";
import "./operators/LesserOrEqual";
import "./operators/In";
import "./operators/InRange";
import "./operators/Ilike";
import "./operators/Has";


let ConditionElement = f.CreateClass("ConditionElement", {
    init(column, operator, anyValue) {
        if ( f.isArray(column) ) {
            anyValue = column[2];
            operator = column[1];
            column = column[0];
        }

        operator = Operator.create(operator);
        let isValidValue = operator.validateValue(anyValue);

        if ( !isValidValue ) {
            throw new Error("(" + operator.constructor.className + ") invalid value: " + anyValue, anyValue);
        }

        if ( !f.isString(column) || !/^\w+$/i.test(column) ) {
            throw new Error("invalid column: " + column);
        }

        this.column = column;
        this.operator = operator;
        this.value = anyValue;

        this.noRows = false;
        if ( this.operator instanceof NoRows ) {
            this.noRows = true;
        }
    },

    compile2js() {
        if ( this.noRows ) {
            return "false";
        }

        // left is variable in compiled function
        let left = this.column;
        let right = this.value;

        // undefined, null
        if ( right == null ) {
            right = null;
        }

        return this.operator.compile2js(left, right);
    },

    compile2json() {
        if ( this.noRows ) {
            // битлджус
            return ["noRows", "noRows", "noRows"];
        }

        let value = this.value;
        if ( value == null ) {
            value = null;
        }

        return [this.column, this.operator.literal, value];
    },

    isEmpty() {
        return false;
    },

    hasColumn(column) {
        return this.column == column;
    }
});

export default ConditionElement;
